import dateUtils from '@/common/dateUtils';

export default {
  getRelatedArtifacts(files, dutyTitle) {
    return files.filter((f) => f.title !== dutyTitle && f.dienst.split(',').includes(dutyTitle));
  },
  /**
   * Returns the Monday based day of week (Monday=1, Sunday=7)
   * @param {Date} date - a date
   * @returns the day of week
   */
  getDayOfWeek(date) {
    let dayOfWeek = date.getDay(); // monday=1, sunday=7
    dayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    return dayOfWeek;
  },

  /**
   * Checks if day is accepted, that is within dayTypes (including) boundaries
   * + dates additionally added
   * - dates removed
   * @param {Date} date - a date formatted as ISO string
   * @param {Object} fahrplanFile - the Fahrdienst File to check
   * @param {number} dayType - numbers 1 (=Monday) to 7 (=Sunday). From to (including).
   *                           examples:
   *                           11 = Monday only
   *                           12 = Monday to Tuesday
   *                           26 = Tuesday to Saturday
   * @param {Array} additionalFahrdienstDays - list of additional dates which are valid next to the day type.
   * @param {Array} cancelledFahrdienstDays - list of days which are not valid
   * @returns true if the date is accepted
   */
  // Date saved on DB 2022-03-29
  // serialized in backend as 2022-03-28T22:00:00.000Z=new Date(2022,04,29).toISOString()
  // use in frontend by Date.parse('2022-03-28T22:00:00.000Z')
  isDayAccepted({ date, dayType, verkehrsPeriodenKalender = [], additionalFahrdienstDays = [], cancelledFahrdienstDays = [] }) {
    let dayOfWeek = this.getDayOfWeek(date);
    let dayTypeArray = `${dayType}`.split('').map((a) => Number(a));
    let holiday = verkehrsPeriodenKalender.find((i) => {
      return dateUtils.isSameDate(date, new Date(Date.parse(i.datum)));
    });
    if (holiday) {
      //console.debug('found holiday to be a ', holiday.verkehrsperiode);
      dayOfWeek = holiday.verkehrsperiode;
    }

    let isDayAcceptedByDayType = dayTypeArray[0] <= dayOfWeek && dayTypeArray[1] >= dayOfWeek;
    //console.debug('isDayAcceptedByDayType', isDayAcceptedByDayType);
    if (isDayAcceptedByDayType) {
      // if it is accepted, we need to check if the date has been manually removed
      let removedItem = cancelledFahrdienstDays.find((c) => dateUtils.isSameDate(date, new Date(Date.parse(c.datum))));
      //console.debug('found removed?', removedItem);
      if (removedItem) return false;
      return true;
    } else {
      // if it is not accepted, we need to check if the date has been manually added
      let added = additionalFahrdienstDays.find((c) => dateUtils.isSameDate(date, new Date(Date.parse(c.datum))));
      //console.debug('found added?', added);
      if (added) return true;
      return false;
    }
  },
  /**
   * Calculate duties with files at the given dates. Used in FahrdienstHeader.
   * @param {*} param0
   * @returns {Array} duty files valid at the given date
   */
  getDutiesAtSelectedDate({
    date,
    dutyFilesTypeIdFk,
    fahrplanDuties,
    files,
    instance,
    verkehrsPeriodenKalender,
    additionalFahrdienstDays,
    cancelledFahrdienstDays,
  }) {
    let dutiesAtSelectedDate = fahrplanDuties.filter((d) => {
      let filesValidAt = this.findDutyFilesValidAt({
        dutyTitle: d.title,
        dutyFilesTypeIdFk,
        date,
        instance,

        files,
        verkehrsPeriodenKalender,
        additionalFahrdienstDays,
        cancelledFahrdienstDays,
      });
      return filesValidAt.length > 0;
    });

    console.debug('dutiesAtSelectedDate', dutiesAtSelectedDate);
    return dutiesAtSelectedDate;
  },
  /**
   * Check if a fahrplan file exists which is valid at the given date. The file is selected in case
   * the file title field equals the duty title (and not as expected by a file.dienst.includes(dutyTitle) condition, which would result in multiple files)
   */
  /**
   *
   * @param {Date} date - the date to check if files are valid at that given date
   * @param {String} dutyTitle - the title of the duty (which might be used for selection by file.title)
   * @param allNonDuties
   * @param dutyFilesTypeIdFk
   * @param instance
   * @param files
   * @param verkehrsPeriodenKalender
   * @param additionalFahrdienstDays
   * @param cancelledFahrdienstDays
   * @returns
   */
  findDutyFilesValidAt({
    date,
    dutyTitle,
    allNonDuties = false,

    dutyFilesTypeIdFk = 0,

    instance,
    files,

    verkehrsPeriodenKalender = [],
    additionalFahrdienstDays = [],
    cancelledFahrdienstDays = [],
  }) {
    // console.debug("--------------------------------")
    let dutyFiles;
    if (allNonDuties) {
      dutyFiles = files;
    } else {
      dutyFiles = files.filter((f) => f.inst == instance && (f.dienst === 'Alle' || dutyTitle == f.title || f.dienst.includes(dutyTitle))); // BOGG selects files with an exact match of the title instead of like expected by a f.dienst.includes(dutyTitle)
    }

    // console.debug('dutyFiles after instance and dienst/title filter', dutyFiles);
    dutyFiles = dutyFiles.filter((f) => {
      return f.typeIdFk === dutyFilesTypeIdFk;
    });
    // console.debug('dutyFiles after filtering if excludeDuties', excludeDuties, dutyFiles);
    dutyFiles = dutyFiles.filter((f) =>
      this.isDayAccepted({
        date,
        dayType: f.tagtyp,
        verkehrsPeriodenKalender,
        additionalFahrdienstDays: additionalFahrdienstDays.filter((d) => d.fahrplanFileIdFk === f.id),
        cancelledFahrdienstDays: cancelledFahrdienstDays.filter((d) => d.fahrplanFileIdFk == f.id),
      })
    );
    // console.debug('dutyFiles after filtering of isDayAccepted', dutyFiles);
    return dutyFiles;
  },
};
